import { useUserStore } from '../stores/UserStore';

export const useIsGroupBlocked = (): boolean => {
	const isGroupBlocked = useUserStore(state => state.isGroupBlocked);

	return isGroupBlocked ?? false;
};
